export class TestResultComment {
  type: string | undefined;
  text: string | undefined;
}
